import barba from '@barba/core'
import gsap from 'gsap'

let collectionsImages = null
let element = null
let transition = 'default'

export default {
  active () {
    return element || collectionsImages
  },

  elementClear () {
    collectionsImages = null
    element = null
    transition = 'default'
  },

  init () {    
    barba.hooks.beforeLeave(data => {
      let target = data.trigger
      transition = 'default'

      // collections -> collection
      if (data.current.namespace === 'collections') {
        while (target && !target.classList.contains('cm-collectionslist-collection')) {
          target = target.parentNode
        }
        if (target) {
          transition = 'collectionsToCollection'
          collectionsImages = Array.from(target.querySelectorAll('.cm-collectionslist-images img'))
        }
      }

      // default
      if (transition === 'default') {
        while (target && !target.hasAttribute('data-image-transition-from')) {
          target = target.parentNode
        }
        if (target) {
          const uiImageEl = target.classList.contains('ui-image') ? target : target.querySelector('.ui-image')
          element = uiImageEl ? uiImageEl : null
        }
      }

      return Promise.resolve()
    })
  },

  leave () {
    if (transition === 'collectionsToCollection' && collectionsImages) {
      collectionsImages = collectionsImages.map(el => this.cloneElement(el))
      return
    }

    element = this.cloneElement(element)
  },

  enter (data) {
    if (transition === 'collectionsToCollection' && collectionsImages) {
      return this.enterCollection(data)
    }

    const uiImageEl = data.next.container.querySelector('.ui-image[data-image-transition-to]')
    
    if (uiImageEl) {
      uiImageEl.style.opacity = 0 // hidden new image
      const uiImageImg = element.querySelector('img')
      const tl = gsap.timeline({
        onComplete: () => {
          element.parentNode.removeChild(element)
          uiImageEl.style.opacity = null
          this.elementClear()
        }
      })
      const rect = uiImageEl.getBoundingClientRect()

      // center inner image
      tl.to(
        uiImageImg,
        {
          y: 0,
          duration: 1,
          ease: 'power2.inOut'
        },
        0
      )
      
      // move wrapper in position
      tl.to(
        element,
        {
          top: rect.y,
          left: rect.x,
          width: uiImageEl.offsetWidth,
          height: uiImageEl.offsetHeight,
          duration: 1.15,
          ease: 'power2.inOut'
        },
        0
      )

      return tl
    }
    return null
  },

  enterCollection (data) {
    const targetImages = Array.from(data.next.container.querySelectorAll('.cm-collection-item:not(.glide__slide--clone) img'))
    

    if (targetImages && collectionsImages) {
      const tl = gsap.timeline({
        onComplete: () => {
          collectionsImages.forEach(el => {
            el.parentNode.removeChild(el)
          })
          this.elementClear()
          targetImages.forEach(el => {
            el.style.opacity = null
          })
        }
      })

      // loop new images
      targetImages.forEach((targetImg, i) => {
        targetImg.style.opacity = 0

        const rect = targetImg.getBoundingClientRect()

        if (collectionsImages[i]) {
          // move img in position
          tl.to(
            collectionsImages[i],
            {
              top: rect.y,
              left: rect.x,
              width: targetImg.offsetWidth,
              height: targetImg.offsetHeight,
              duration: 1.15,
              ease: 'power2.inOut'
            },
            0
          )
        }

        return tl
      })
    }

    return null
  },

  cloneElement (el) {
    if (!el) {
      return null
    }

    const clonedElement = el.cloneNode(true)
    const rect = el.getBoundingClientRect()
    
    clonedElement.style.position = 'fixed'
    clonedElement.style.top = `${rect.top}px`
    clonedElement.style.left = `${rect.left}px`
    clonedElement.style.width = `${el.offsetWidth}px`
    clonedElement.style.height = `${el.offsetHeight}px`
    clonedElement.style.zIndex = 70

    if (clonedElement.tagName === 'IMG') {
      clonedElement.style.objectFit = 'cover'
      clonedElement.style.objectPosition = 'center'
    }

    document.body.appendChild(clonedElement)

    return clonedElement
  }
}
